/**
 * A grade picked from a list (#954) instead of typed, so state paperwork and close-out's "move up a grade" always get a
 * grade they understand. Values match close-out's nextGrade: 'Pre-K', 'K', '1st' … '12th'. A grade typed before the
 * list existed is matched to it where it can be ("4th grade", "Grade 4", "kindergarten"), else kept as its own option.
 */

const ord = (n: number) => `${n}${n >= 11 && n <= 13 ? 'th' : (['th', 'st', 'nd', 'rd'][n % 10] ?? 'th')}`;

export const GRADES: { value: string; label: string }[] = [
  { value: 'Pre-K', label: 'Pre-K' },
  { value: 'K', label: 'Kindergarten' },
  ...Array.from({ length: 12 }, (_, i) => ({ value: ord(i + 1), label: `${ord(i + 1)} grade` })),
];

/** A stored grade as one of the list's values, or itself when it isn't one. */
export function normalizeGrade(g: string): string {
  const t = g.trim();
  if (!t) return '';
  if (/^pre-?k/i.test(t)) return 'Pre-K';
  if (/^k(indergarten)?$/i.test(t)) return 'K';
  const m = /^(?:grade\s*)?(\d{1,2})(?:st|nd|rd|th)?(?:\s*grade)?$/i.exec(t);
  if (m && Number(m[1]) >= 1 && Number(m[1]) <= 12) return ord(Number(m[1]));
  return t;
}

export function GradeSelect({
  value,
  onChange,
  required,
  className,
  emptyLabel = 'Not set',
}: {
  value: string;
  onChange: (grade: string) => void;
  required?: boolean;
  className?: string;
  emptyLabel?: string;
}) {
  const v = normalizeGrade(value);
  const other = v && !GRADES.some((g) => g.value === v);
  return (
    <select className={className} value={v} onChange={(e) => onChange(e.target.value)} required={required} aria-required={required || undefined}>
      <option value="">{emptyLabel}</option>
      {other && <option value={v}>{v}</option>}
      {GRADES.map((g) => (
        <option key={g.value} value={g.value}>
          {g.label}
        </option>
      ))}
    </select>
  );
}
